


// import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import {
//   Applicant,
//   Group,
//   Member,
//   PlatformAdminState,
//   Service,
//   User
// } from '../../../types/ndisSection/platformAdminTypes';

// // Avatar fetching function
// export const getAvatarUrl = async (avatarPath: string, retryCount = 1): Promise<string> => {
//   if (!avatarPath || avatarPath === 'brand') {
//     console.log('No avatar path provided or default brand, using default');
//     return '/default-avatar.png';
//   }

//   const attemptFetch = async (attempt: number): Promise<string> => {
//     try {
//       console.log(`Attempt ${attempt} to fetch avatar: ${avatarPath}`);
//       const response = await axiosInstance.get('/avatar/get-avatar', {
//         params: { path: avatarPath },
//         responseType: 'blob'
//       });

//       const blobUrl = URL.createObjectURL(response.data);
//       console.log(`Avatar fetched successfully: ${blobUrl}`);
//       return blobUrl;
//     } catch (error: any) {
//       console.error(`Error fetching avatar (attempt ${attempt}) for path ${avatarPath}:`, {
//         status: error.response?.status,
//         message: error.message,
//         data: error.response?.data
//       });
//       if (attempt < retryCount) {
//         console.log(`Retrying avatar fetch for ${avatarPath} after 1s...`);
//         await new Promise((resolve) => setTimeout(resolve, 1000));
//         return attemptFetch(attempt + 1);
//       }
//       return '/default-avatar.png';
//     }
//   };

//   return attemptFetch(1);
// };

// // Extend PlatformAdminState to include avatarUrls
// interface ExtendedPlatformAdminState extends PlatformAdminState {
//   avatarUrls: Record<string, string>;
// }

// const initialState: ExtendedPlatformAdminState = {
//   members: [],
//   applicants: [],
//   roles: [],
//   services: [],
//   groups: [],
//   loading: false,
//   error: null,
//   avatarUrls: {}
// };

// const slice = createSlice({
//   name: 'platformAdmin',
//   initialState,
//   reducers: {
//     setLoading(state, action: PayloadAction<boolean>) {
//       state.loading = action.payload;
//     },
//     hasError(state, action: PayloadAction<string | null>) {
//       state.error = action.payload;
//     },
//     getMembersSuccess(state, action: PayloadAction<Member[]>) {
//       state.members = action.payload;
//     },
//     getApplicantsSuccess(state, action: PayloadAction<Applicant[]>) {
//       state.applicants = action.payload;
//     },
//     getRolesSuccess(state, action: PayloadAction<string[]>) {
//       state.roles = action.payload;
//     },
//     getServicesSuccess(state, action: PayloadAction<Service[]>) {
//       state.services = action.payload;
//     },
//     getGroupsSuccess(state, action: PayloadAction<Group[]>) {
//       state.groups = action.payload;
//     },
//     addGroupSuccess(state, action: PayloadAction<Group>) {
//       state.groups.push(action.payload);
//     },
//     updateGroupSuccess(state, action: PayloadAction<Group>) {
//       const index = state.groups.findIndex((group) => group.group_id === action.payload.group_id);
//       if (index !== -1) {
//         state.groups[index] = action.payload;
//       }
//     },
//     deleteGroupSuccess(state, action: PayloadAction<string>) {
//       state.groups = state.groups.filter((group) => group.group_id !== action.payload);
//     },
//     getAvatarSuccess(state, action: PayloadAction<{ userId: string; url: string }>) {
//       state.avatarUrls[action.payload.userId] = action.payload.url;
//     }
//   }
// });

// export default slice.reducer;

// // Thunks
// const handleError = (dispatch: any, error: any) => {
//   console.log("handleError,error",error)
//   dispatch(slice.actions.hasError(error?.response?.data?.error||error?.message || 'An error occurred'));
//   console.error('API Error:', error);
// };

// export const fetchGroups = () => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     const { data } = await axiosInstance.get<Group[]>('projectmanagement/get-groups-list');
//     dispatch(slice.actions.getGroupsSuccess(data));
//   } catch (error) {
//     handleError(dispatch, error);
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const addGroup = (groupData: any) => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     await axiosInstance.post('/projectmanagement/create-group', groupData, {
//       headers: { 'Content-Type': 'application/json' }
//     });
//     dispatch(fetchGroups());
//   } catch (error) {
//     handleError(dispatch, error);
//     dispatch(fetchGroups());
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const updateGroup = (groupData: any) => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     await axiosInstance.post('/projectmanagement/update-group', groupData, {
//       headers: { 'Content-Type': 'application/json' }
//     });

//     dispatch(fetchGroups());
//   } catch (error) {
//     handleError(dispatch, error);
//     dispatch(fetchGroups());
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const deleteGroup = (groupId: string) => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     await axiosInstance.post('/projectmanagement/delete-group', { group_id: groupId });
//     dispatch(slice.actions.deleteGroupSuccess(groupId));
//   } catch (error) {
//     handleError(dispatch, error);
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const fetchMembers = () => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     const { data } = await axiosInstance.get<Member[]>('/users');
//     dispatch(slice.actions.getMembersSuccess(data));
//   } catch (error) {
//     handleError(dispatch, error);
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const fetchApplicants = () => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     const { data } = await axiosInstance.get<Applicant[]>('/newapplicants/list');
//     dispatch(slice.actions.getApplicantsSuccess(data));
//   } catch (error) {
//     handleError(dispatch, error);
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const fetchRoles = () => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     const { data } = await axiosInstance.get<{ roles: string[] }>('/groups/list');
//     dispatch(slice.actions.getRolesSuccess(data.roles));
//   } catch (error) {
//     handleError(dispatch, error);
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const fetchServices = () => async (dispatch: any) => {
//   dispatch(slice.actions.setLoading(true));
//   try {
//     const { data } = await axiosInstance.get<Service[]>('/services/list');
//     dispatch(slice.actions.getServicesSuccess(data));
//   } catch (error) {
//     handleError(dispatch, error);
//   } finally {
//     dispatch(slice.actions.setLoading(false));
//   }
// };

// export const fetchAvatar = (user: User) => async (dispatch: any) => {
//   if (!user.avatar || user.avatar === 'brand') {
//     dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url: '/default-avatar.png' }));
//     return;
//   }
//   try {
//     const url = await getAvatarUrl(user.avatar);
//     dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url }));
//   } catch (error) {
//     handleError(dispatch, error);
//     dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url: '/default-avatar.png' }));
//   }
// };

// export const fetchGroupAvatar = (group: Group) => async (dispatch: any) => {
//   if (!group.avatar || group.avatar === 'brand') {
//     dispatch(
//       slice.actions.getAvatarSuccess({ userId: group.group_id, url: '/default-avatar.png' })
//     );
//     return;
//   }
//   try {
//     const url = await getAvatarUrl(group.avatar);
//     dispatch(slice.actions.getAvatarSuccess({ userId: group.group_id, url }));
//   } catch (error) {
//     handleError(dispatch, error);
//     dispatch(
//       slice.actions.getAvatarSuccess({ userId: group.group_id, url: '/default-avatar.png' })
//     );
//   }
// };

// export const fetchAvatars = (users: User[]) => async (dispatch: any) => {
//   try {
//     const fetchPromises = users
//       .filter((user) => user.avatar && user.avatar !== 'brand')
//       .map(async (user) => ({
//         userId: user.id,
//         url: await getAvatarUrl(user.avatar || '')
//       }));
//     const results = await Promise.all(fetchPromises);
//     results.forEach(({ userId, url }) => {
//       dispatch(slice.actions.getAvatarSuccess({ userId, url }));
//     });
//     users
//       .filter((user) => !user.avatar || user.avatar === 'brand')
//       .forEach((user) => {
//         dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url: '/default-avatar.png' }));
//       });
//   } catch (error) {
//     handleError(dispatch, error);
//   }
// };

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import {
  Applicant,
  Group,
  Member,
  PlatformAdminState,
  Service,
  User
} from '../../../types/ndisSection/platformAdminTypes';

const GROUPS_MEMORY_TTL_MS = 30 * 1000;

let lastGroupsFetchedAt = 0;
let lastGroupsSnapshot: Group[] = [];

const invalidateGroupsCache = () => {
  lastGroupsFetchedAt = 0;
  lastGroupsSnapshot = [];
};

const getLoggedInEmailFromState = (state: any): string | null => {
  const possibleEmail =
    state?.loginSignup?.user?.email ||
    state?.appData?.user_details?.email ||
    state?.profileSettings?.user?.email ||
    null;

  if (typeof possibleEmail === 'string' && possibleEmail.trim()) {
    return possibleEmail.trim();
  }

  try {
    const rawUserDetails = localStorage.getItem('user-details');
    if (!rawUserDetails) {
      return null;
    }

    const parsedUserDetails = JSON.parse(rawUserDetails);
    const fallbackEmail = parsedUserDetails?.email;
    return typeof fallbackEmail === 'string' && fallbackEmail.trim()
      ? fallbackEmail.trim()
      : null;
  } catch {
    return null;
  }
};

const normalizeGroupsResponse = (payload: any): Group[] => {
  const source = Array.isArray(payload)
    ? payload
    : payload?.groups || payload?.userGroups || payload?.data || [];

  if (!Array.isArray(source)) {
    return [];
  }

  return source
    .filter((group) => group && (group.group_id || group.id))
    .map((group) => ({
      ...group,
      group_id: String(group.group_id || group.id),
      label: String(group.label || group.name || ''),
      administrators: Array.isArray(group.administrators) ? group.administrators : [],
      services: Array.isArray(group.services) ? group.services : []
    }));
};

const requestGroupsByEmail = async (email: string): Promise<Group[]> => {
  const { data } = await axiosInstance.get(
    `/groups/groups-by-username?email=${encodeURIComponent(email)}`
  );
  return normalizeGroupsResponse(data);
};

const requestAllGroups = async (): Promise<Group[]> => {
  const { data } = await axiosInstance.get('/projectmanagement/get-groups-list');
  return normalizeGroupsResponse(data);
};

// Avatar fetching function
export const getAvatarUrl = async (avatarPath: string, retryCount = 1): Promise<string> => {
  if (!avatarPath || avatarPath === 'brand') {
    console.log('No avatar path provided or default brand, using default');
    return '/default-avatar.png';
  }

  const attemptFetch = async (attempt: number): Promise<string> => {
    try {
      console.log(`Attempt ${attempt} to fetch avatar: ${avatarPath}`);
      const response = await axiosInstance.get('/avatar/get-avatar', {
        params: { path: avatarPath },
        responseType: 'blob'
      });

      const blobUrl = URL.createObjectURL(response.data);
      console.log(`Avatar fetched successfully: ${blobUrl}`);
      return blobUrl;
    } catch (error: any) {
      console.error(`Error fetching avatar (attempt ${attempt}) for path ${avatarPath}:`, {
        status: error.response?.status,
        message: error.message,
        data: error.response?.data
      });
      if (attempt < retryCount) {
        console.log(`Retrying avatar fetch for ${avatarPath} after 1s...`);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return attemptFetch(attempt + 1);
      }
      return '/default-avatar.png';
    }
  };

  return attemptFetch(1);
};

// Extend PlatformAdminState to include avatarUrls and snackbar
interface ExtendedPlatformAdminState extends PlatformAdminState {
  avatarUrls: Record<string, string>;
  snackbar: {
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';
  };
}

const initialState: ExtendedPlatformAdminState = {
  members: [],
  applicants: [],
  roles: [],
  services: [],
  groups: [],
  loading: false,
  error: null,
  avatarUrls: {},
  snackbar: {
    open: false,
    message: '',
    severity: 'info'
  }
};

const slice = createSlice({
  name: 'platformAdmin',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    showSnackbar(
      state,
      action: PayloadAction<{
        message: string;
        severity: 'success' | 'error' | 'info' | 'warning';
      }>
    ) {
      state.snackbar = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity
      };
    },
    closeSnackbar(state) {
      state.snackbar.open = false;
    },
    getMembersSuccess(state, action: PayloadAction<Member[]>) {
      state.members = action.payload;
    },
    getApplicantsSuccess(state, action: PayloadAction<Applicant[]>) {
      state.applicants = action.payload;
    },
    getRolesSuccess(state, action: PayloadAction<string[]>) {
      state.roles = action.payload;
    },
    getServicesSuccess(state, action: PayloadAction<Service[]>) {
      state.services = action.payload;
    },
    getGroupsSuccess(state, action: PayloadAction<Group[]>) {
      state.groups = action.payload;
    },
    addGroupSuccess(state, action: PayloadAction<Group>) {
      state.groups.push(action.payload);
    },
    updateGroupSuccess(state, action: PayloadAction<Group>) {
      const index = state.groups.findIndex((group) => group.group_id === action.payload.group_id);
      if (index !== -1) {
        state.groups[index] = action.payload;
      }
    },
    deleteGroupSuccess(state, action: PayloadAction<string>) {
      state.groups = state.groups.filter((group) => group.group_id !== action.payload);
    },
    getAvatarSuccess(state, action: PayloadAction<{ userId: string; url: string }>) {
      state.avatarUrls[action.payload.userId] = action.payload.url;
    }
  }
});

export const { closeSnackbar, showSnackbar } = slice.actions;
export default slice.reducer;

// Thunks
const handleError = (dispatch: any, error: any) => {
  const errorMessage = error?.response?.data?.error || error?.message || 'An error occurred';
  dispatch(
    showSnackbar({
      message: errorMessage,
      severity: 'error'
    })
  );
  console.error('API Error:', error);
};

export const fetchGroups = () => async (dispatch: any) => {
  if (
    lastGroupsFetchedAt &&
    Date.now() - lastGroupsFetchedAt < GROUPS_MEMORY_TTL_MS &&
    lastGroupsSnapshot.length > 0
  ) {
    dispatch(slice.actions.getGroupsSuccess(lastGroupsSnapshot));
    return;
  }

  dispatch(slice.actions.setLoading(true));
  try {
    const normalizedGroups = await requestAllGroups();
    lastGroupsFetchedAt = Date.now();
    lastGroupsSnapshot = normalizedGroups;
    dispatch(slice.actions.getGroupsSuccess(normalizedGroups));
  } catch (error) {
    handleError(dispatch, error);
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const addGroup = (groupData: any) => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    await axiosInstance.post('/projectmanagement/create-group', groupData, {
      headers: { 'Content-Type': 'application/json' }
    });
    invalidateGroupsCache();
    await dispatch(fetchGroups());
    dispatch(
      showSnackbar({
        message: 'Group created successfully!',
        severity: 'success'
      })
    );
    return true;
  } catch (error) {
    handleError(dispatch, error);
    invalidateGroupsCache();
    await dispatch(fetchGroups());
    return false;
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const updateGroup = (groupData: any) => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    await axiosInstance.post('/projectmanagement/update-group', groupData, {
      headers: { 'Content-Type': 'application/json' }
    });
    invalidateGroupsCache();
    await dispatch(fetchGroups());
    dispatch(
      showSnackbar({
        message: 'Group updated successfully!',
        severity: 'success'
      })
    );
    return true;
  } catch (error) {
    handleError(dispatch, error);
    invalidateGroupsCache();
    await dispatch(fetchGroups());
    return false;
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const deleteGroup = (groupId: string) => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    await axiosInstance.post('/projectmanagement/delete-group', { group_id: groupId });
    invalidateGroupsCache();
    dispatch(slice.actions.deleteGroupSuccess(groupId));
    dispatch(
      showSnackbar({
        message: 'Group deleted successfully!',
        severity: 'success'
      })
    );
  } catch (error) {
    handleError(dispatch, error);
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const fetchMembers = () => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    const { data } = await axiosInstance.get<Member[]>('/users');
    dispatch(slice.actions.getMembersSuccess(data));
  } catch (error) {
    handleError(dispatch, error);
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const fetchApplicants = () => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    const { data } = await axiosInstance.get<Applicant[]>('/newapplicants/list');
    dispatch(slice.actions.getApplicantsSuccess(data));
  } catch (error) {
    handleError(dispatch, error);
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const fetchRoles = () => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    const { data } = await axiosInstance.get<{ roles: string[] }>('/groups/list');
    dispatch(slice.actions.getRolesSuccess(data.roles));
  } catch (error) {
    handleError(dispatch, error);
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const fetchServices = () => async (dispatch: any) => {
  dispatch(slice.actions.setLoading(true));
  try {
    const { data } = await axiosInstance.get<Service[]>('/services/list');
    dispatch(slice.actions.getServicesSuccess(data));
  } catch (error) {
    handleError(dispatch, error);
  } finally {
    dispatch(slice.actions.setLoading(false));
  }
};

export const fetchAvatar = (user: User) => async (dispatch: any) => {
  if (!user.avatar || user.avatar === 'brand') {
    dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url: '/default-avatar.png' }));
    return;
  }
  try {
    const url = await getAvatarUrl(user.avatar);
    dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url }));
  } catch (error) {
    handleError(dispatch, error);
    dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url: '/default-avatar.png' }));
  }
};

export const fetchGroupAvatar = (group: Group) => async (dispatch: any) => {
  if (!group.avatar || group.avatar === 'brand') {
    dispatch(
      slice.actions.getAvatarSuccess({ userId: group.group_id, url: '/default-avatar.png' })
    );
    return;
  }
  try {
    const url = await getAvatarUrl(group.avatar);
    dispatch(slice.actions.getAvatarSuccess({ userId: group.group_id, url }));
  } catch (error) {
    handleError(dispatch, error);
    dispatch(
      slice.actions.getAvatarSuccess({ userId: group.group_id, url: '/default-avatar.png' })
    );
  }
};

export const fetchAvatars = (users: User[]) => async (dispatch: any) => {
  try {
    const fetchPromises = users
      .filter((user) => user.avatar && user.avatar !== 'brand')
      .map(async (user) => ({
        userId: user.id,
        url: await getAvatarUrl(user.avatar || '')
      }));
    const results = await Promise.all(fetchPromises);
    results.forEach(({ userId, url }) => {
      dispatch(slice.actions.getAvatarSuccess({ userId, url }));
    });
    users
      .filter((user) => !user.avatar || user.avatar === 'brand')
      .forEach((user) => {
        dispatch(slice.actions.getAvatarSuccess({ userId: user.id, url: '/default-avatar.png' }));
      });
  } catch (error) {
    handleError(dispatch, error);
  }
};